import { computed, ref } from "vue";
import { isNumber } from "lodash";

export const useFilterGroup = (filterGroup) => {
    const multiple = computed(() => filterGroup.value.multiple);
    const options = computed(() => filterGroup.value.options);
    const modelValue = computed(() => filterGroup.value.modelValue);
    const handle = computed(() => filterGroup.value.handle);
    const perPage = computed(() => filterGroup.value.per_page);

    const showAll = ref(!isNumber(perPage.value));

    const loadMore = () => {
        showAll.value = !showAll.value;
    };

    const selectedOptions = computed(() => {
        let filteredOptions = [];
        if (multiple.value) {
            if (handle.value === "categories") {
                filteredOptions = options.value.filter((item) => {
                    if (item.ids) {
                        return (
                            item.ids.some((id) =>
                                modelValue.value.includes(id)
                            ) || modelValue.value.includes(item.id)
                        );
                    } else {
                        return modelValue.value.includes(item.id);
                    }
                });
            } else {
                filteredOptions = options.value.filter((item) =>
                    modelValue.value.includes(item.id)
                );
            }
        }
        return filteredOptions;
    });

    const deselectedOptions = computed(() => {
        if (
            handle.value === "categories" &&
            options.value.some((item) => item.ids)
        ) {
            if (multiple.value) {
                return options.value.filter((item) => {
                    if (item.ids) {
                        return !item.ids.some((id) =>
                            modelValue.value.includes(id)
                        );
                    } else {
                        return !modelValue.value.includes(item.id);
                    }
                });
            } else {
                return [];
            }
        } else {
            if (multiple.value) {
                return options.value.filter(
                    (item) => !modelValue.value.includes(item.id)
                );
            } else {
                return options.value;
            }
        }
    });

    const allOptions = computed(() => {
        const combinedOptions = selectedOptions.value.concat(
            deselectedOptions.value
        );
        return showAll.value
            ? combinedOptions
            : combinedOptions.slice(0, perPage.value);
    });

    return {
        selectedOptions,
        deselectedOptions,
        allOptions,
        loadMore,
        showAll,
    };
};
